import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase/app";
import { EventLocations } from "@/enums/EventLocations";
import {ValidationRules} from "@/utils/validation-rules";

export default {
    name: "careLevelsDialog",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            selectedWingsIds: [],
            selectedWingsIdsOld: [],
            dialog: false,
            loading: false,
            isAdd: false,
            isUpdate: false,
            careLevelId: null,
            name: null
        }
    },
    computed: {
        wings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        facilityId() {
            return this.$store.state.authModule.currentFacility;
        },
        careLevelsName(): string[] {
            return this.$store.state.careLevelsModule.careLevels.map(x => x.name);
        },
        rules() {
            return {
                addName: [ValidationRules.required, ValidationRules.stringExistsInList(this.name, this.careLevelsName, 'name')],
                updateName: [ValidationRules.required],
                wings: [ValidationRules.required]
            }
        }
    },
    methods: {
        async submit() {
            this.loading = true;

            const isValid = await this.$refs.addCareLevelsForm.validate()
            if (!isValid) {
                this.loading = false;
                return;
            }

            if (this.isAdd) {
                await this.addCareLevel();
            }

            if (this.isUpdate) {
                await this.updateCareLevel();
            }

            this.close();
        },

        async addCareLevel() {

            const form: any = {
                name: this.name,
                wingsIds: this.selectedWingsIds,
            }

            console.log(form)

            await this.$store.dispatch("addCareLevel", form)
                .then(() => {
                    this.$toast.open({
                        message: `Care Level successfully added`,
                        type: "success"
                    });
                }).catch((error) => {
                    this.$toast.open({
                        message: `${error.message}`,
                        type: "error"
                    });
                });
        },

        async updateCareLevel() {
            const form: any = {
                id: this.careLevelId,
                name: this.name,
                wingsIds: this.selectedWingsIds,
            }

            await this.$store.dispatch("updateCareLevel", form)
                .then(async () => {

                    await this.changeCareLevelOnWings(form);

                    await this.removeCareLevelFromRemovedWings();

                    await this.$store.dispatch("getEventWings");
                    
                    await this.$store.dispatch("getCareLevels")

                    await this.$store.dispatch("getEventLocations");

                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['LevelsOfCare.SuccessfullyUpdated'],
                        type: "success"
                    });

                }).catch((error) => {
                    this.$toast.open({
                        message: `${error.message}`,
                        type: "error"
                    });
                });
        },

        open(type, item) {
            this.dialog = true;

            this.$store.dispatch("getEventWings");

            if (type === "add") {
                this.isAdd = true;
            }

            if (type === "update") {
                this.isUpdate = true;
                this.careLevelId = item.id;
                this.name = item.name;
                this.selectedWingsIds = item.wingsIds;
                this.selectedWingsIdsOld = item.wingsIds
            }
        },

        async changeCareLevelOnWings(form: any) {
                await firebase
                  .firestore()
                  .collection("eventLocations")
                  .where("facilityId", "==", this.facilityId)
                  .where("careLevelId", "==", form.id)
                  .get()
                  .then((querySnapshot) => {
                      if(querySnapshot.docs && querySnapshot.docs.length) {
                          querySnapshot.docs.forEach((item) => {
                            if(item.data().type === EventLocations.Wing){
                                item.ref.update({ careLevelName: form.name })
                            }
                        })
                      }
                  })
        },   
        
        async removeCareLevelFromRemovedWings() {

            const deletedWingsIds = this.selectedWingsIdsOld.filter(id => !this.selectedWingsIds.includes(id));

            if(!deletedWingsIds.length) return

            deletedWingsIds.forEach(async (id) => {
                await firebase.firestore().collection("eventLocations").doc(id).update({ careLevelId: null, careLevelName: null })
            })
        },

        close() {
            this.loading = false;
            this.dialog = false;
            this.isAdd = false;
            this.isUpdate = false;
            this.name = null;
            this.careLevelId = null;
            this.selectedWingsIds = [];
            this.$refs.observer.reset();
        }
    }
}